import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a071b94f6558f00147a0720_1780394273327/futureminds/src/app/all-olympiads/page.tsx");
